import React, { useCallback, useEffect } from 'react';
import useAnimationStore from '../../common/store/useAnimationStore';

const useAnimation = (
  wrapper: React.RefObject<HTMLDivElement>,
  mask: React.RefObject<HTMLDivElement>
) => {
  const timeline = useAnimationStore(useCallback(state => state.loading, []));

  useEffect(() => {
    timeline
      .to(mask.current, {
        duration: 2,
        ease: "power2.out",
        display: "block",
        opacity: 1
      })
      .to([wrapper.current, mask.current], {
        duration: 0,
        display: "none"
      });

    return () => { timeline.clear() }
  }, []);
}

export default useAnimation;